import React from 'react';
import * as clevertapOpenPlatformComponent from 'clevertap/openPlatform/component';
import Title from '../../Title';
import styles from './BuiltWithMoka.css';

class BuiltWithMoka extends React.PureComponent {
  render() {
    return (
      <div className={styles.wrapper}>
        <Title title="Build with Moka" />
        <p className={styles.description}>
          Develop customized solutions for merchants to get reports, manage
          products, review transactions and handle operations that keep
          businesses running.
        </p>
        <p>Moka Open Platform is simple, powerful, secure and reliable.</p>
        <a
          className={`btn btn-primary ${styles.btnBuildWithMoka}`}
          href="https://developers.mokapos.com"
          onClick={clevertapOpenPlatformComponent.devPlatform}
        >
          Go to Developer Platform
        </a>
      </div>
    );
  }
}

export default BuiltWithMoka;
